export default __webpack_public_path__ + "static/media/1_8.8a0fe45b.png";